module.exports = __webpack_public_path__ + "img/talent_header1.48df6515.jpg";